<template>
  <transition name="fade">
    <div v-show="visible" class="delete-confirm-mask">
      <div class="delete-confirm-container">
        <div class="delete-confirm-content">
          <h3>{{ title }}</h3>
          <div class="message">{{ message }}</div>
          <div class="buttons">
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="danger" @click="handleConfirm">确定</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'deleteConfirm',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '永久删除对话',
    },
    message: {
      type: String,
      default: '确定要删除该项吗？',
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    handleConfirm() {
      this.$emit('confirm');
      this.$emit('update:visible', false);
    },
    handleCancel() {
      this.$emit('cancel');
      this.$emit('update:visible', false);
    },
  },
  watch: {},
};
</script>

<style scoped lang="less">
.delete-confirm-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.delete-confirm-container {
  background: #fff;
  border-radius: 16px;
  padding: 25px 25px 20px;
  min-width: 400px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.delete-confirm-content {
  display: flex;
  flex-direction: column;
  //align-items: center;

  h3 {
    color: #444;
    margin-bottom: 20px;
  }
}

.warning-icon {
  color: #e6a23c;
  font-size: 24px;
  margin-bottom: 10px;
}

.message {
  margin-bottom: 20px;
  font-size: 16px;
  color: #606266;
}

.buttons {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 30px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.el-button--default {
  color: #333 !important;
  background-color: #fff !important;
  border-color: #fff !important;

  &:hover {
    background-color: rgba(65, 70, 76, 0.05) !important;
    border-color: rgba(65, 70, 76, 0.05) !important;
  }
}
</style>
